<template>
    <el-dialog 
        class="mutex-settings" 
        :title="$t('main.MutualExclusionInfluence')" 
        :visible.sync="mutexvisible" 
        :close-on-click-modal="false" 
        :close-on-press-escape="false" 
        :modal-append-to-body="false"
    >
        <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('main.MutualExclusion')" name="first">
                <el-button 
                    icon="el-icon-circle-plus-outline" 
                    size="small" 
                    v-if="mutexList.length == 0" 
                    @click="addMutex()"
                >{{$t('main.NewlyAdded')}}</el-button>
                <div class="labelClass" v-for="(item, index) in mutexList" :key="index">
                    <el-select
                        size="small"
                        multiple
                        collapse-tags
                        v-model="item.oneList"
                        :placeholder="$t('main.PleaseSelectAnOption')"
                    >
                        <template v-for="info in activeQuestion.optionList">
                            <el-option
                                v-if="item.twoList.indexOf(info.oid) == -1"
                                :key="info.oid"
                                :label="$functions.htmlFormat(info.labelName)"
                                :value="info.oid"
                            ></el-option>
                        </template>
                    </el-select>
                    <span class="and">{{$t('main.Give')}}</span>
                    <el-select
                        size="small"
                        multiple
                        collapse-tags
                        v-model="item.twoList"
                        :placeholder="$t('main.PleaseSelectAnOption')"
                    >   
                        <template v-for="info in activeQuestion.optionList">
                            <el-option
                                v-if="item.oneList.indexOf(info.oid) == -1"
                                :key="info.oid"
                                :label="$functions.htmlFormat(info.labelName)"
                                :value="info.oid"
                            ></el-option>
                        </template>
                    </el-select>
                    <span class="and">{{$t('main.MutualExclusion')}}</span>
                    <div class="icon_num">
                        <i class="icon iconfont iconjian" @click="removeMutex(index)"></i>
                        <i class="icon iconfont iconjia" @click="addMutex(index)"></i>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('main.Effect')" name="second">
                <el-button 
                    icon="el-icon-circle-plus-outline" 
                    size="small" 
                    v-if="influenceList.length == 0" 
                    @click="addInfluence()"
                >{{$t('main.NewlyAdded')}}</el-button>
                <div class="labelClass" v-for="(item, index) in influenceList" :key="index">
                    <el-select
                        size="small"
                        multiple
                        collapse-tags
                        v-model="item.oneList"
                        :placeholder="$t('main.PleaseSelectAnOption')"
                        value-key="qid"
                    >
                        <el-option
                            v-for="info in activeQuestion.optionList"
                            :key="info.oid"
                            :label="$functions.htmlFormat(info.labelName)"
                            :value="info.oid"
                        ></el-option>
                    </el-select>
                    <span class="and">{{$t('main.MutualInfluence')}}</span>
                    <div class="icon_num">
                        <i class="icon iconfont iconjian" @click="removeInfluence(index)"></i>
                        <i class="icon iconfont iconjia" @click="addInfluence(index)"></i>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="mutexvisible = false">{{$t('main.cancel2')}}</el-button>
            <el-button size="small" type="primary" @click="mutexSubmit">{{ $t('main.ok2') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { v1 as UUID } from 'uuid';
export default {
    name: 'MutexSettings', // 互斥&影响
    props: {
        activeQuestion: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            mutexvisible: false,
			activeName: 'first',
            mutexList: [],
            influenceList: []
        }
    },
	watch:{
	},
    methods: {
        // 父级调用(初始化)
        toSetMutex() {
            this.init()
            this.mutexvisible = true
        },
        init() {
            if (!this.activeQuestion.mutexList){
                this.$set(this.activeQuestion, 'mutexList', [])
            }
            this.mutexList = this.activeQuestion.mutexList
            if (!this.activeQuestion.influenceList){
                this.$set(this.activeQuestion, 'influenceList', [])
            }
            this.influenceList = this.activeQuestion.influenceList
        },
        addMutex(index) {
            let obj = {
                id: UUID(),
                oneList: [],
                twoList: []
            }
			if (index != 'undefined') {
				this.mutexList.splice(index + 1, 0, obj);
			} else {
				this.mutexList.push(obj);
			}
        },
        removeMutex(index) {
            this.mutexList.splice(index, 1)
        },
        addInfluence(index) {
            let obj = {
                id: UUID(),
                oneList: [],
            }
			if (index != 'undefined') {
				this.influenceList.splice(index + 1, 0, obj);
			} else {
				this.influenceList.push(obj);
			}
        },
        removeInfluence(index) {
            this.influenceList.splice(index, 1)
        },
        mutexSubmit() {
            this.activeQuestion.mutexList = this.mutexList
            this.activeQuestion.influenceList = this.influenceList
            this.mutexvisible = false
        }
    }
}
</script>
<style scoped lang="scss">
	.labelClass{
		display: flex;
		align-items: center;
	}
    .and{
        display: inline-block;
        margin: 0 10px;
    }
	.labelClass+.labelClass{
        margin-top: 10px;
    }
	.icon{
		cursor: pointer;
	}
    /deep/.el-select .el-tag{
        max-width: 74%;
    }
    /deep/.el-dialog{
        width: 700px;
    }
</style>